import React, { useEffect, useState } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, Switch, DatePicker, InputNumber, TimePicker } from "antd";
import ModalCommon from "../../components/Modal";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const TEXT = {
    onOffGame: "Bật/Tắt game",
    eventStartTime: "Thời gian bắt đầu sự kiện",
    eventEndTime: "Thời gian kết thúc sự kiện",
    resetSchedule: "Lịch reset định kỳ",
    frequency: "Tần suất",
    resetDay: "Ngày reset",
    time: "Giờ",
    monthly: "Hằng tháng",
    weekly: "Hằng tuần",
    daily: "Hằng ngày",
}

const OnOffGame = () => {
    const [configGame, setConfigGame] = useState();
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const [isShowGame, setIsShowGame] = useState();
    const [resetFrequency, setResetFrequency] = useState("daily");
    const [resetDay, setResetDay] = useState(1);
    const [resetTime, setResetTime] = useState(dayjs("00:00:00", "HH:mm:ss"));

    useEffect(() => {
        getDataConfig();
    }, []);

    const getDataConfig = async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data.data;
            const isGameEnabled = data.schedule?.isGameEnabled;
            
            setConfigGame({
                isGameEnabled: isGameEnabled,
                eventStart: data.schedule?.eventStart,
                eventEnd: data.schedule?.eventEnd
            });
            
            // Khởi tạo isShowGame từ API data (chỉ set lần đầu khi chưa có giá trị)
            if (isGameEnabled !== undefined) {
                setIsShowGame(prev => prev === undefined ? isGameEnabled : prev);
            }
            
            // Load resetSchedule từ API
            if (data.schedule?.resetSchedule) {
                const resetSchedule = data.schedule?.resetSchedule;
                // Map type từ MONTHLY/WEEKLY/DAILY sang lowercase
                const frequency = resetSchedule.type?.toLowerCase() || "daily";
                setResetFrequency(frequency);
                
                // Set day: dayOfMonth cho monthly, có thể là dayOfWeek cho weekly
                const day = resetSchedule.dayOfMonth || resetSchedule.dayOfWeek || 1;
                setResetDay(day);
                
                // Set time từ object {hour, minute, second}
                if (resetSchedule.time) {
                    const { hour = 0, minute = 0, second = 0 } = resetSchedule.time;
                    const timeString = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`;
                    setResetTime(dayjs(timeString, "HH:mm:ss"));
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);
            setIsShowModalSuccess(true);
            
            // Format resetSchedule
            const resetScheduleData = {
                type: resetFrequency.toUpperCase(), // MONTHLY, WEEKLY, DAILY
                time: {
                    hour: resetTime.hour(),
                    minute: resetTime.minute(),
                    second: resetTime.second()
                }
            };
            
            // Thêm dayOfMonth cho monthly, dayOfWeek cho weekly
            if (resetFrequency === "monthly") {
                resetScheduleData.dayOfMonth = resetDay;
            } else if (resetFrequency === "weekly") {
                resetScheduleData.dayOfWeek = resetDay;
            } else if (resetFrequency === "daily") {
                resetScheduleData.dayOfMonth = resetDay;
            }
            
            const body = {
                config : {
                    schedule: {
                        isGameEnabled: isShowGame,
                        eventStart: dateFrom ? formatRequest(dateFrom) : configGame?.eventStart,
                        eventEnd: dateTo ? formatRequest(dateTo) : configGame?.eventEnd,
                        resetSchedule: resetScheduleData
                    }
                }
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
        } catch (err) {
            console.log(err);
        }
    };

    const formatRequest = (dateFm) => {
        const date = dayjs.tz(dateFm, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok');
        const output = date.format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        return output
    }

    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const onChangeDate = (value, type) => {
        if (value) {
            const formatted = value.format("YYYY-MM-DD HH:mm:ss");
            if (type === "from") setDateFrom(formatted);
            else setDateTo(formatted);
        } else if (type === "from") {
            setDateFrom(null);
        } else {
            setDateTo(null);
        }
    };

    const checkFlagShow = () => {
        const isCheck = configGame.isGameEnabled;
        return isCheck;
    };

    const handleChangeSwitch = (e) => {
        setIsShowGame(e);
    };

    return (
        <div className="col-12">
            <div className="col-12">
                <div className="flex w-full">
                    <div className="flex flex-col w-full items-center justify-center">
                        <div className="col-10 mt-2 flex flex-col items-center justify-center">
                            <div className="flex w-full items-center">
                                <div className="flex w-[20%] justify-end mr-10">{TEXT.onOffGame}:</div>
                                {configGame?.eventStart && <div className="w-[60%]">
                                    <Switch
                                        checkedChildren="On"
                                        unCheckedChildren="Off"
                                        checked={isShowGame !== undefined ? isShowGame : checkFlagShow()}
                                        style={{ width: 60, marginTop: "5px" }}
                                        onChange={(e) => handleChangeSwitch(e)}
                                    />
                                </div>}
                            </div>
                            {configGame?.eventStart && <div className="flex w-full items-center mt-4">
                                <div className="flex w-[20%] justify-end mr-10">{TEXT.eventStartTime}:</div>
                                <div className="w-[60%]">
                                    <DatePicker
                                        placeholder=""
                                        onChange={(value) => onChangeDate(value, "from")}
                                        defaultValue={dayjs(configGame?.eventStart, "YYYY-MM-DD HH:mm:ss")}
                                        format={"DD-MM-YYYY HH:mm:ss"}
                                        style={{ width: "100%" }}
                                        disabledDate={(d) =>
                                            !d ||
                                            (dateTo
                                              ? d.isAfter(dayjs(dateTo), "day")
                                              : false)
                                        }
                                        showTime
                                    />
                                </div>
                            </div>}
                            {configGame?.eventEnd && <div className="flex w-full items-center mt-4">
                                <div className="flex w-[20%] justify-end mr-10">{TEXT.eventEndTime}:</div>
                                <div className="w-[60%]">
                                    <DatePicker
                                        placeholder=""
                                        defaultValue={dayjs(configGame?.eventEnd, "YYYY-MM-DD HH:mm:ss")}
                                        onChange={(value) => onChangeDate(value, "to")}
                                        format={"DD-MM-YYYY HH:mm:ss"}
                                        style={{ width: "100%" }}
                                        disabledDate={(d) =>
                                            !d ||
                                            (dateFrom
                                              ? d.isBefore(dayjs(dateFrom), "day")
                                              : false)
                                        }
                                        showTime
                                    />
                                </div>
                            </div>}
                            <div className="w-full mt-6">
                                <div className="flex w-full items-center mb-4">
                                    <div className="flex w-[20%] justify-end mr-10 font-bold text-lg">{TEXT.resetSchedule}</div>
                                </div>
                                <div className="flex w-full items-center mt-4">
                                    <div className="flex w-[20%] justify-end mr-10">{TEXT.frequency}:</div>
                                    <div className="w-[60%] flex gap-2">
                                        <Button 
                                            type="default"
                                            onClick={() => setResetFrequency("monthly")}
                                            style={{ 
                                                borderColor: resetFrequency === "monthly" ? "#1890ff" : undefined,
                                                color: resetFrequency === "monthly" ? "#1890ff" : undefined,
                                                borderWidth: resetFrequency === "monthly" ? "2px" : undefined
                                            }}
                                        >
                                            {TEXT.monthly}
                                        </Button>
                                        <Button 
                                            type="default"
                                            onClick={() => setResetFrequency("weekly")}
                                            style={{ 
                                                borderColor: resetFrequency === "weekly" ? "#1890ff" : undefined,
                                                color: resetFrequency === "weekly" ? "#1890ff" : undefined,
                                                borderWidth: resetFrequency === "weekly" ? "2px" : undefined
                                            }}
                                        >
                                            {TEXT.weekly}
                                        </Button>
                                        <Button 
                                            type="default"
                                            onClick={() => setResetFrequency("daily")}
                                            style={{ 
                                                borderColor: resetFrequency === "daily" ? "#1890ff" : undefined,
                                                color: resetFrequency === "daily" ? "#1890ff" : undefined,
                                                borderWidth: resetFrequency === "daily" ? "2px" : undefined
                                            }}
                                        >
                                            {TEXT.daily}
                                        </Button>
                                    </div>
                                </div>
                                <div className="flex w-full items-center mt-4">
                                    <div className="flex w-[20%] justify-end mr-10">{TEXT.resetDay}:</div>
                                    <div className="w-[60%]">
                                        <InputNumber
                                            min={1}
                                            max={resetFrequency === "daily" ? 31 : resetFrequency === "weekly" ? 7 : 31}
                                            value={resetDay}
                                            onChange={(value) => setResetDay(value || 1)}
                                            disabled={resetFrequency === "daily"}
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </div>
                                <div className="flex w-full items-center mt-4">
                                    <div className="flex w-[20%] justify-end mr-10">{TEXT.time}:</div>
                                    <div className="w-[60%]">
                                        <TimePicker
                                            value={resetTime}
                                            onChange={(time) => setResetTime(time || dayjs("00:00:00", "HH:mm:ss"))}
                                            format="HH:mm:ss"
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-10 mt-5 flex items-center justify-center">
                            <Button type="primary" onClick={handleShowModal}>
                                Cập nhật
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                    }}
                />
            )}
        </div>
    );
};

export default OnOffGame;
